// extracted by mini-css-extract-plugin
module.exports = {"sermonPlayer":"SermonPlayer_sermonPlayer__Lg3BE","brand":"SermonPlayer_brand__PmgjY","content":"SermonPlayer_content__3odsc","msg":"SermonPlayer_msg__1odLC"};